import React, { Component } from 'react';
import { Table,Grid,Button,Header,Modal,Card,Input,Dimmer,Loader,Breadcrumb,Checkbox,Popup,Icon} from 'semantic-ui-react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import SideLeftUncoverRecipes from './SidebarRecipes';
import { categoryRecipeActions } from '../_actions';
import {toaster_dispatch} from '../_helpers';
import {FormattedMessage,injectIntl} from 'react-intl';
//import img_categoriesRecipes from '../Assets/categoriesRecipes.jpeg'
import {styles} from './Styles';
import img_categories from '../Assets/categories.png'

class CategoriesRecipe extends Component {
    constructor(props) {
        super(props);
        this.state = { newCategory: '' }
        this.state = { activeModalDelete: null }
        this.state = { activeModalEdit: null }
        this.hideModal = this.hideModal.bind(this);
        //this.hideErrorNotification = this.hideErrorNotification.bind(this);
        //this.showErrorNotification = this.showErrorNotification.bind(this);

        props.dispatch(categoryRecipeActions.do_count_recipes());
        props.dispatch(categoryRecipeActions.getAll());
    }  

/*
     hideErrorNotification() {
        const { dispatch } = this.props;
        this.setState({ errorNotification: false })
        this.setState({ activeModalDelete: null })
        this.setState({ activeModalEdit: null })
        dispatch(alertActions.clear());
        window.location.reload();
    }

    showErrorNotification() {
        this.setState({ errorNotification: true })
    }*/

    onNewCategoryChange = (e) => {
        e.preventDefault();
        this.setState({ newCategory: e.target.value });
    }

    onEditCategory = (e) => {
        e.preventDefault();
        this.setState({ newCategory: e.target.value });
    }

    addCategory = (e) => {
        e.preventDefault();
        let newCategory = this.state.newCategory;

        if (newCategory && newCategory !=''){
            newCategory = newCategory.slice(0,50);
            this.props.dispatch(categoryRecipeActions.add(newCategory));
        }
    }

    editCategory (event,category) {
        event.preventDefault();
        let newCategory = this.state.newCategory;
        
        if (newCategory !=''){
            newCategory = newCategory.slice(0,50);
            this.props.dispatch(categoryRecipeActions.update(category.id,newCategory,category.is_active));
        }
    }

    deleteCategory (event,index) {
        event.preventDefault();
        // -- Implementation with modals for deletion
        this.props.dispatch(categoryRecipeActions.delete(index))
        
        // -- Implementation with new page for deletion
        //history.push('/deleterecipe/'+index)
    }

    deleteClickHandler (event,index) {
        event.preventDefault();
        this.setState({ activeModalDelete: index});
    };

    editClickHandler (event,index,name) {
        event.preventDefault();
        this.setState({ activeModalEdit: index});
        this.setState({ newCategory: name });
    };

    hideModal() {
        this.setState({ activeModalDelete: null });
        this.setState({ activeModalEdit: null });
        this.setState({ newCategory: '' });
    }

    toaster(dispatch,alert){
        const {intl} = this.props;
        this.hideModal();
        toaster_dispatch(dispatch,alert,intl);
    }

    onActiveChange = (event, category) => {
        event.preventDefault();
        this.props.dispatch(categoryRecipeActions.update(category.id,
                                                         category.name,
                                                         event.target.checked,
                                                         false));
    }

/*     sendPOSCategory (event,index) {
        event.preventDefault();
        this.props.dispatch(categoryRecipeActions.sendPOS(index));
    } */
    
    addCategoriesRows(categoriesRecipe){
        return categoriesRecipe.items.map((category,index) => {
                return (
                    <Table.Row key={index} >
                        <Table.Cell >
                            <a href="#" 
                               onClick={(event)=>this.editClickHandler(event,index,category.name)}>{category.name}
                            </a>
                        </Table.Cell>
                        <Table.Cell textAlign='center'>{category.nb_recipes}</Table.Cell>
                        <Table.Cell textAlign='center'>
                                <Checkbox  id={index}
                                       checked = {category.is_active}
                                       style={{marginTop:'0em'}}
                                       onChange={(event) =>this.onActiveChange(event,category)}/>
                        </Table.Cell>
                        <Table.Cell textAlign='right'>
{/*                             <Popup trigger=
                                {<Button className="ui small icon button" 
                                onClick={(event)=>this.editCategory(event,category.id)}>
                                <i className="edit icon"></i>
                                 </Button>} 
                                content='Rename'> 

                                 <Input
                                        type="text"
                                        placeholder={category.name}
                                        id="renameCategory"
                                        value={this.state.newCategory}
                                        onChange={this.onRenameCategory}
                                        style={{minWidth:'15em',maxWidth:'30em'}}/>

                            </Popup> */}
{/*                             <Button basic className="ui icon button circular" color='blue'
                                onClick={(event)=>this.editClickHandler(event,index,category.name)}>
                                <i className="edit icon"></i>
                                 </Button>
                            <Button basic id={index} className="ui icon button circular" color='grey'
                                onClick={(event) => this.deleteClickHandler(event,index)}>
                                <i className="trash alternate outline icon"></i>
                            </Button> */}
                            <Icon name="edit outline" size='large' color='blue' style={{cursor:'pointer'}} 
                                        onClick={(event)=>this.editClickHandler(event,index,category.name)}/>&nbsp;
{/*                             <Icon name="tv" size='large' color='teal' style={{cursor:'pointer'}} 
                                        onClick={(event)=>this.sendPOSCategory(event,category.id)}/>&nbsp; */}
                            <Icon name="trash alternate outline" size='large' color='grey' style={{cursor:'pointer'}}
                                        onClick={(event) => this.deleteClickHandler(event,index)}/>
                            <Modal id={index}
                                   open={this.state.activeModalEdit === index}
                                   dimmer='default' 
                                   size='tiny' 
                                   style={styles.Modal} 
                                   onClose={this.hideModal}>
                                <Header icon='edit' content={<FormattedMessage id="categories.recipes.modal.rename.title"
                                                                                defaultMessage='Rename category'/>} />
                                <Modal.Content>
                                    <Input
                                        type="text"
                                        //placeholder="Renaming"
                                        id="renameCategory"
                                        value={this.state.newCategory}
                                        onChange={this.onEditCategory}
                                        style={{minWidth:'15em',maxWidth:'30em'}}/>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button basic color='grey' onClick={this.hideModal}>
                                        <FormattedMessage id="categories.recipes.modal.rename.button.no"
                                                          defaultMessage='Cancel'/>
                                    </Button>
                                    <Button color='teal' 
                                        labelPosition='right' 
                                        content={<FormattedMessage id="categories.recipes.modal.rename.button.yes"
                                                                    defaultMessage='Apply'/>}
                                        icon='checkmark' 
                                        onClick={(event) =>this.editCategory(event,category)}>
                                    </Button>
                                    </Modal.Actions>
                            </Modal> 
                             <Modal id={index}
                                   open={this.state.activeModalDelete === index}
                                   dimmer='default' 
                                   size='tiny' 
                                   style={styles.Modal} 
                                   onClose={this.hideModal}>
                                <Header icon='trash alternate outline' content={<FormattedMessage id="categories.recipes.modal.delete.title"
                                                                                defaultMessage='Deletion confirmation'/>} />
                                <Modal.Content>
                                    <p>
                                        <FormattedMessage id="categories.recipes.modal.delete.message"
                                                         defaultMessage='Really sure to delete "{name}" ?'
                                                         values={{name:category.name}}/>
                                    </p>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button basic color='grey' onClick={this.hideModal}>
                                        <FormattedMessage id="categories.recipes.modal.delete.button.no"
                                                          defaultMessage='Cancel'/>
                                    </Button>
                                    <Button color='red' 
                                        labelPosition='right' 
                                        content={<FormattedMessage id="categories.recipes.modal.delete.button.yes"
                                                                   defaultMessage='Yes'/>}
                                        icon='checkmark' 
                                        onClick={(event) =>this.deleteCategory(event,category.id)}/>
                                    </Modal.Actions>
                            </Modal> 
                        </Table.Cell>
                     </Table.Row>
                );
        });
    }


    render() { 
        const { categoriesRecipe,alert,dispatch,loading_cr } = this.props;

        return ( 
            <div>
                <SideLeftUncoverRecipes>
                <Grid stackable style={styles.FontLato13}>
                    <Grid.Row columns={1}>
                    <Breadcrumb  style={{background:'#fcfcfc'}}>
                            <Breadcrumb.Section link as={Link} to={'/dashboard/'}><FormattedMessage id="categories.recipes.link.dashboard"
                                                                        defaultMessage='Dashboard'/></Breadcrumb.Section>
                            <Breadcrumb.Divider icon='right chevron'/>
                            <Breadcrumb.Section link as={Link} to={'/recipes/'}><FormattedMessage id="categories.recipes.link.recipes"
                                                                        defaultMessage='Recipes'/></Breadcrumb.Section>
                            <Breadcrumb.Divider icon='right chevron'/>
                            <Breadcrumb.Section active><FormattedMessage id="categories.recipes.link.categories"
                                                                        defaultMessage='Categories'/></Breadcrumb.Section>
                    </Breadcrumb>
                    </Grid.Row>
                       <Grid.Row columns={1}>
                                <Grid.Column width={6}>
                                    <Header as='h2'>
                                        <img src={img_categories} style={{width:'40px'}}/>
                                        <Header.Content>
                                            <FormattedMessage id="categories.recipes.page.title"
                                                              defaultMessage='Categories'/>
                                            <Header.Subheader><FormattedMessage id="categories.recipes.page.subtitle"
                                                              defaultMessage='Add your recipes categories'/></Header.Subheader>
                                        </Header.Content>
                                    </Header>
                                </Grid.Column >
                        </Grid.Row> 
{/*                     <Grid.Row columns={1}>
                        <Grid.Column width={14}>
                                <Message icon >
                                    <Image src={img_categoriesRecipes} rounded/>
                                    <Message.Content>
                                        <Message.Header>
                                                <FormattedMessage id="categories.recipes.header.caption.title"
                                                                     defaultMessage='Recipe Categories: '/>
                                        </Message.Header>
                                        <div  style={inlineStyle}>
                                                <FormattedMessage id="categories.recipes.header.caption.subtitle"
                                                                 defaultMessage=' Customize your recipe categories.' />
                                        </div>
                                    </Message.Content>
                                </Message>
                                <br/><br/>
                        </Grid.Column>
                    </Grid.Row> */}
                    {/*{alert.message &&     
                       <div className={`alert ${alert.type}`}>{alert.message}</div> */}
                    {alert.message && this.toaster(dispatch,alert)}
                    <Grid.Row columns={1}/>
                    <Grid.Row columns={2} >
                        <Grid.Column width={5}> 
                            <p style={styles.FontLato13}>
                                <FormattedMessage id="categories.recipes.newrecipe.title"
                                                  defaultMessage='Create a new recipe category' /> 
                            </p>
                            <Card color={'blue'} style={styles.FontLato13} fluid>
                                <Card.Content >
                                    <Header as='h5'>
                                        <FormattedMessage id="categories.recipes.card.newrecipe.title"
                                                          defaultMessage='Name' /> 
                                    </Header>
                                    <FormattedMessage id="categories.recipes.card.newrecipe.placeholder"
                                                        defaultMessage='category name'>
                                        {placeholder =>  
                                                <Input fluid size='large'
                                                    type="text"
                                                    placeholder={placeholder}
                                                    id="newCategory"
                                                    value={this.state.newCategory}
                                                    onChange={this.onNewCategoryChange}
                                                    //style={{minWidth:'15em',maxWidth:'30em'}}
                                                    />}
                                    </FormattedMessage>
                                    <br/><br/>
                                    <Button color='blue' floated='right'
                                        onClick={(event) =>this.addCategory(event)}>
                                        <FormattedMessage id="categories.recipes.card.button.create"
                                                          defaultMessage='Create' /> 
                                    </Button>
                                </Card.Content> 
                            </Card>
                        </Grid.Column>
                        <Grid.Column width={7}> 
                            <p style={styles.FontLato14Border}>
                               {categoriesRecipe && categoriesRecipe.items && 
                                  <span style={{'font-weight': 'bold;'}}>{categoriesRecipe.items.length}{' '}</span>
                               }
                               <FormattedMessage id="categories.recipes.currentrecipe.title"
                                                  defaultMessage='categories available' />
                            </p>
                            <Dimmer.Dimmable>
                                        <Dimmer active={((loading_cr))} blurring inverted>
                                           <Loader inverted content='Loading' />
                                        </Dimmer> 
                            <Table selectable responsive color={'blue'} fluid unstackable singleLine>
                                <Table.Header style={styles.FontLato13}>
                                    <Table.Row>
                                        <Table.HeaderCell>
                                             <FormattedMessage id="categories.recipes.currentrecipe.table.row.name"
                                                              defaultMessage='Name' /> 
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign='center'>
                                            <FormattedMessage id="categories.recipes.currentrecipe.table.row.nbrecipes"
                                                              defaultMessage='Nb Recipes' /> 
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign='center'>
                                            <FormattedMessage id="categories.recipes.currentrecipe.table.row.active"
                                                              defaultMessage='Active in export files' />{' '} 
                                            <Popup trigger={<Icon name='info circle' color='teal' link size='large' />}
                                                                on='hover'
                                                                position = 'top right'
                                                                flowing>
                                                             <Icon name='info circle' color='teal' size='large'/>
                                                            <FormattedMessage id="categories.recipes.currentrecipe.table.row.active.help"
                                                                               defaultMessage="You can Enable/Disable categories for your export files: listings, inventories" />
                                            </Popup>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign='right'></Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {categoriesRecipe && categoriesRecipe.items &&
                                      this.addCategoriesRows(categoriesRecipe)}
                                </Table.Body>
                            </Table>
                           </Dimmer.Dimmable>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                </SideLeftUncoverRecipes>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { categoriesRecipe,alert,dispatch } = state;
    const { loading_cr } = state.categoriesRecipe;
    return {
        categoriesRecipe,
        loading_cr,
        alert,
        dispatch
    };
}

const connectedCategoriesRecipe = injectIntl(connect(mapStateToProps)(CategoriesRecipe));
export { connectedCategoriesRecipe as CategoriesRecipe };
 